import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  path: string;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.path = this.router.url;
  }
}
